// 生成 trackId
export function createSu() {
  return `${new Date().getTime()}ehll${parseInt(
    String(Math.random() * (10000000000 + 1)),
    10
  )}`;
}

// 获取 token
export function getToken(): string {
  return localStorage.getItem('token') || '';
}
// 存储 token
export function setToken(token: string): void {
  localStorage.setItem('token', token || '');
}
// 清除
export function removeToken() {
  localStorage.removeItem('token');
}

// 获取 test_user
export function getTestUser(): string {
  return localStorage.getItem('test_user') || '';
}
// 存储 test_user
export function setTestUser(testUser: string) {
  localStorage.setItem('test_user', testUser || '');
}
// 清除 test_user
export function removeTestUser() {
  localStorage.removeItem('test_user');
}

// ------------------- Start 处理 responseType: text 类型数据, 将大数转化为字符串
// 吐出一个不存在于 str 中的标识字符串
const pickTagStr = (str: string) => {
  let tag = '@rr_';
  let index = 0;
  while (str.indexOf(tag) !== -1) {
    tag += index++;
  }
  return tag;
};
// 能否被JSON.parse，可能是字符串 不一定是JSON
const canJsonParse = (str: string) => {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
};
// 处理文本中超长的数字变量，通过正则将其转为字符串
const changeLongToString = (str: string) => {
  const tag = pickTagStr(str);
  return str
    .replace(/:\d{17,}/g, (item) => `:"${tag}_r_${item.substr(1)}"`)
    .replace(new RegExp(`${tag}_r_\\s`, 'g'), '')
    .replace(new RegExp(`${tag}_r_`, 'g'), '');
};
// 解析 responseType: text 类型数据
export const parseTextResponseData = (str: string) => {
  let strStr = str;
  if (typeof strStr !== 'string') {
    return strStr;
  }
  try {
    // 先用最简单的方式处理(异常情况：用户输入字段(如：备注等)匹配到替换规则，导致JSON错位，需特殊处理)
    const response = JSON.parse(changeLongToString(strStr));
    return response;
  } catch (e) {
    const reg = /:\d{17,}/;
    const tag = pickTagStr(strStr);
    // 直接对整个str遍历，逐个处理超长的数据类型
    while (reg.test(strStr)) {
      const strBack = strStr;
      strStr = strStr.replace(reg, (item) => `:"${tag}_r_${item.substr(1)}"`); // 需转换 _r_ 占位并添加""
      // 变化后解析失败，判定为无需转换的内容。回退并添加无需转换标识
      if (!canJsonParse(strStr)) {
        strStr = strBack.replace(reg, (item) => `:${tag}_n_${item.substr(1)}`); // 不需要转换 _n_ 占位
      }
    }
    const result = strStr
      .replace(new RegExp(`${tag}_r_\\s`, 'g'), '')
      .replace(new RegExp(`${tag}_r_`, 'g'), '')
      .replace(new RegExp(`${tag}_n_\\s`, 'g'), '')
      .replace(new RegExp(`${tag}_n_`, 'g'), '');

    // 仍有错就抛出去，方便排查
    return JSON.parse(result);
  }
};
// ------------------- End 处理 responseType: text 类型数据, 将大数转化为字符串

